import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ExcellentQuality from '@/components/video-diagnostic/ExcellentQuality.vue'
import PoorQuality from '@/components/video-diagnostic/PoorQuality.vue'
import { getQualityScore } from '@/composables/video-diagnostic/useGetQualityScore'
import { Stage, Topic, QualityScore } from '@/types/enums/video-diagnostic.enum'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { ref, watch } from 'vue'
import QualityCard from './QualityCard.vue'

interface QualityTestEmits {
  (e: 'nextStage', value: number): void
  (e: 'updateTopic', value: IUpdateTopic): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Quality',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateTopic"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const { totalQualityScore } = getQualityScore()

watch(
  () => props.stage,
  async (stage, prevStage) => {
    if (prevStage === Stage.QUALITY && stage === Stage.CONNECTIVITY) {
      emit('updateTopic', { topic: Topic.QUALITY, active: false })
    }
    if (stage === Stage.QUALITY) {
      emit('updateTopic', { topic: Topic.QUALITY, active: true })
    }
  },
)

const toggle = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(totalQualityScore) === _unref(QualityScore).Good || _unref(totalQualityScore) === _unref(QualityScore).Excellent)
      ? (_openBlock(), _createBlock(ExcellentQuality, {
          key: 0,
          stage: __props.stage,
          "total-quality-score": _unref(totalQualityScore),
          onNextStage: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage', _unref(Stage).RESULTS))),
          onUpdateToggle: _cache[1] || (_cache[1] = ($event: any) => (toggle.value = true))
        }, null, 8, ["stage", "total-quality-score"]))
      : (_openBlock(), _createBlock(PoorQuality, {
          key: 1,
          stage: __props.stage,
          "total-quality-score": _unref(totalQualityScore),
          onNextStage: _cache[2] || (_cache[2] = ($event: any) => (emit('nextStage', _unref(Stage).RESULTS))),
          onUpdateToggle: _cache[3] || (_cache[3] = ($event: any) => (toggle.value = true))
        }, null, 8, ["stage", "total-quality-score"])),
    _createVNode(_component_Popup, {
      title: "Detailed quality information",
      width: "550",
      open: toggle.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (toggle.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(QualityCard)
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})